import React from "react"
import { AGENDA_COLORS } from "../utils/agendaColors"

export default function AgendaLegend({ compact = false }) {
  const itemStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: compact ? 4 : 6,
    padding: compact ? "4px 7px" : "4px 8px",
    borderRadius: 999,
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    lineHeight: 1,
    flex: "0 0 auto"
  }

  const dotStyle = (background) => ({
    width: compact ? 8 : 9,
    height: compact ? 8 : 9,
    borderRadius: 999,
    background,
    display: "inline-block",
    flexShrink: 0
  })

  const textStyle = {
    fontSize: compact ? 9.5 : 10,
    color: "#475569",
    fontWeight: 800,
    whiteSpace: "nowrap"
  }

  const items = [
    [AGENDA_COLORS.NORMAL, "Normal"],
    [AGENDA_COLORS.RECALL, "Recall"],
    [AGENDA_COLORS.HELD, "Reserva"],
    [AGENDA_COLORS.PLAN, "Plan"],
    [AGENDA_COLORS.PLAN_HELD, compact ? "Plan+res." : "Plan + reserva"]
  ]

  return (
    <div
      style={{
        display: "flex",
        gap: compact ? 5 : 8,
        flexWrap: compact ? "nowrap" : "wrap",
        alignItems: "center",
        marginBottom: compact ? 6 : 10,
        padding: compact ? "4px 5px" : "6px 8px",
        borderRadius: 10,
        background: "#f8fafc",
        border: compact ? "1px solid #eef2f7" : "1px solid #e5e7eb",
        overflowX: compact ? "auto" : "visible",
        WebkitOverflowScrolling: "touch"
      }}
    >
      {!compact ? (
        <div
          style={{
            fontSize: 10,
            fontWeight: 900,
            color: "#334155",
            marginRight: 2,
            whiteSpace: "nowrap"
          }}
        >
          Estado visual
        </div>
      ) : null}

      {items.map(([color, label]) => (
        <div key={label} style={itemStyle}>
          <span style={dotStyle(color)} />
          <span style={textStyle}>{label}</span>
        </div>
      ))}
    </div>
  )
}
